import React, { useState, useEffect } from "react";
import SFTextField from "../../textField";
import SFGenericSearch from "../../typeahead/genericSearch";
import SFSkeleton from "../../skeleton";
import { useTranslation } from "react-i18next";
import DateField from "./dateField";

const Search = (props) => {
  const [source, setSource] = useState(null);
  const { t } = useTranslation();

  let selectedValues = [];
  if (props.value) {
    selectedValues = props.fieldData.multiple
      ? JSON.parse(props.value)
      : [props.value];
  }

  let nullValueFilterLabel =
    props.fieldData?.filterParams?.nullValueFilterLabel ??
    t("components.datagrid.filters.blankValue");

  useEffect(() => {
    setSource(null);
    if (props.fieldData.fetchData) {
      props.fieldData.fetchData().then((res) => {
        setSource(
          res.data.values.map((x) => ({
            value: x === null ? nullValueFilterLabel : x.toString(),
            //display value is the value that will be displayed in the search box
            //if valueFormatter is present we want to use it to format the value
            displayValue:
              x === null
                ? nullValueFilterLabel
                : props.fieldData?.filterParams?.valueFormatter
                  ? props.fieldData.filterParams.valueFormatter({
                    value: x,
                  })
                  : x.toString(),
          }))
        );
      });
    } else {
      setSource(props.fieldData.source);
    }
  }, [props.fieldData.name]);

  //handle on change
  //we want to send the original value of the source to the backend
  const onChangeHandler = (selected, multiple) => {
    if (multiple) {
      props.handleOnChange(
        JSON.stringify(
          selected.map((x) =>
            x === nullValueFilterLabel
              ? null
              : source.find((y) => y.displayValue === x).value
          )
        )
      );
    } else {
      props.handleOnChange(
        source.find((y) => y.displayValue === selected.value).value
      );
    }
  };

  //get selectedValues
  //we want to display the displayValue of the source
  const getSelectedValues = () => {
    return selectedValues.map((x) =>
      x === null
        ? nullValueFilterLabel
        : source.find((y) => y.value === x).displayValue
    );
  };

  if (!source) {
    return <SFSkeleton rows={1} showHeader={false} showFooter={false} />;
  }

  return (
    <SFGenericSearch
      fullWidth
      source={source.map((x) => ({ value: x.displayValue }))}
      hasSearchIcon
      selectedValues={getSelectedValues()}
      multiple={props.fieldData.multiple}
      {...(props.fieldData.multiple
        ? {
          onClose: (selected) => onChangeHandler(selected, true),
        }
        : {
          onSelect: (selected) => onChangeHandler(selected, false),
        })}
    />
  );
};

const CustomValueEditor = (props) => {
  if (props.fieldData.dataType === "date") {
    return <DateField {...props} />;
  } else if (
    props.fieldData.dataType !== "number" &&
    (props.fieldData.source || props.fieldData.fetchData) &&
    props.operator !== "contains" &&
    props.operator !== "doesNotContain"
  ) {
    return <Search {...props} />;
  } else {
    return (
      <SFTextField
        variant="filled"
        value={props.value}
        hiddenLabel
        {...(props.fieldData.dataType === "number" && { type: "number" })}
        onChange={(e) => props.handleOnChange(e.target.value)}
      />
    );
  }
};

export default CustomValueEditor;
